// extracted by mini-css-extract-plugin
export default {"root":"Q2EYv_","title":"TaEqfC","list":"qW0qZK","item":"Aw9eO6","moreLink":"HxCKcc","moreLinkText":"gXoxdi"};